import React from 'react';

import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import { ThemeProvider } from '@material-ui/styles';

import { setEndOfTheDayTime } from 'constants/helper';
import { originalSpacingTheme } from 'constants/theme';

function EmptyText(props, x) {
  return <span />;
}

// for formik
export default function DatePickerField({
  date,
  onChange,
  error,
  isOpen,
  onOpen,
  onClose,
  setIsOpen,
  onError,
  disablePast = false,
  autoOk = false,
  ref,
  clearable = true,
}) {
  // const currentError = form.errors[field.name];

  // const onError = error => {
  //   if (error && error !== currentError) {
  //     form.setFieldError(field.name, error);
  //   }
  // };

  // setting time of the date to the end of the
  function beforeChange(date) {
    if (date) {
      setEndOfTheDayTime(date);
    }
    onChange(date);
  }

  return (
    <ThemeProvider theme={originalSpacingTheme}>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <DatePicker
          clearable={clearable}
          ref={ref}
          value={date}
          open={isOpen}
          error={Boolean(error)}
          onOpen={onOpen}
          onClose={onClose}
          onError={onError}
          onChange={beforeChange} // this function gets date as the only param
          disablePast={disablePast}
          TextFieldComponent={EmptyText}
          autoOk={autoOk}
        />
      </MuiPickersUtilsProvider>
    </ThemeProvider>
  );
}
